import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/users_group_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedUsersGroupFilterView extends Common.Dashboard.Filters.ToggleableUnappliedFilterView
  initialize: ({filter, teams}) ->
    super(filter: filter)
    _.extend(@, Common.Dashboard.Filters.UsersGroupFilterMixin)
    @teams = teams
    @listenTo(@teams, 'update', @render)

  toggleOpenFilter: ->
    @openUsersGroupFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.users_group.modal.title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.users_group.modal.subtitle'
